import React, { Fragment, useMemo } from 'react'

const PALETTE = ['#1cbcb4', '#3A7E8B', '#7fd3ce', '#a7c5cc', '#c9d6d9']

function FleetComposition({ fleet }) {
    const total = (fleet || []).reduce((sum, f) => sum + f.count, 0)

    const segments = useMemo(() => (fleet || []).map((f, i) => ({
        ...f,
        color: PALETTE[i % PALETTE.length],
        fraction: total > 0 ? f.count / total : 0
    })), [fleet, total])

    if(total === 0) {
        return (
            <Fragment>
                <p className='emptyState'>Aucun véhicule validé pour l’instant.</p>
            </Fragment>
        )
    }

  return (
    <Fragment>
        <div className='fleetComposition'>
            <div className='segmentedBar'>
                {segments.map(s => (
                    <div key={s.marque} className='segment' style={{ width: `${s.fraction * 100}%`, backgroundColor: s.color }}></div>
                ))}
            </div>
            <ul className='fleetLegend'>
                {segments.map(s => (
                    <li key={s.marque}>
                        <span className='dot' style={{ backgroundColor: s.color }}></span>
                        <span className='label'>{s.marque}</span>
                        <span className='value'>{s.count}</span>
                    </li>
                ))}
            </ul>
        </div>
    </Fragment>
  )
}

export default FleetComposition
